import { UseCase } from '../UseCase';
import { SessionRepository } from '../../repositories/SessionRepository';
import { AppSession } from '../../models/AppSession';

export class LoginUseCase implements UseCase<LoginRequestDto, AppSession>{
    constructor(
        private sessionRepo: SessionRepository
    ) {
    }

    execute(t: LoginRequestDto): Promise<AppSession> {
        return this.sessionRepo.login(t.pos, t.password, t.user);
    }

}

export class LoginRequestDto {
    constructor(
        public pos: string,
        public password: string,
        public user: string | undefined,
    ) { }
}